module.exports = __webpack_public_path__ + "static/media/Follower_Button-4.10e2f233.png";